<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h2 class="title-main">PORTFOLIO</h2>
      <span class="title-sub">TOSHIHIRO YUASA</span>
    </fade-in-top-title>
    <fade-in-main>
      <div class="container container-works">
        <div class="works-contents">
          <article
          v-for="(workContent,index) in workContents"
          :key="workContent.id"
          @mouseover="mouseOverAction(index)"
          @mouseleave="mouseLemoveAction(index)">
            <router-link
            :to="workContent.to">
              <img
              :src="workContent.src">
              <transition name="fade">
                  <div
                  v-show="imgTitle && index === imgIndex"
                    class="works-contents-img">
                    <div class="works-contents-img-title">
                      <h3>{{ workContent.title }}</h3>
                      <p>{{ workContent.subtitle }}</p>
                    </div>
                  </div>
              </transition>
            </router-link>
          </article>
        </div>
      </div>
      <div class="top-view-more">
        <router-link to="/works">
          View more
        </router-link>
      </div>
    </fade-in-main>
  </main>
</template>


<script>
import FadeInMain from '@/components/FadeInMain.vue';
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import { WorkPreview } from '@/WorkPreview';

export default {
  data() {
    return {
      workContents: [
        {
          id: 1,
          title: 'introduction',
          subtitle: 'このサイトについて',
          src: require('@/assets/images/introduction01.png'),
          to: '/introduction'
        },
        {
          id: 2,
          title: 'Wine_UENO',
          subtitle: '社内のカリキュラムで制作',
          src: require('@/assets/images/works-01_ueno-wine.png'),
          to: '/work/workContents01'
        },
        {
          id: 3,
          title: 'Instagram 働く＆リフレッシュキャンペーン',
          subtitle: '社内のカリキュラムで制作',
          src: require('@/assets/images/works-02_abbeco.png'),
          to: '/work/workContents02'
        }
      ]
    }
  },
  mixins: [ WorkPreview ],
  components: {
    FadeInMain,FadeInTopTitle
  }
}
</script>

<style lang="scss" scoped>

.title-main {
  font-size: 30px;
  margin-bottom: 10px;
}

.title-sub {
  font-size: 18.5px;
}

.top-view-more {
  text-decoration: none;
  color: #000;
  position: relative;
  display: inline-block;
  &::after {
    position: absolute;
    left: 0;
    content: '';
    width: 0;
    bottom: -2px;
    height: 2px;
    background: $colorBrown;
    opacity: 0;
    visibility: hidden;
    transition: .3s;
  }
}

.top-view-more:hover::after,
.top-view-more:focus::after {
  opacity: 1;
  width: 100%;
  visibility: visible;
}
</style>